export default __webpack_public_path__ + "static/media/preview-email.bf6360c0.png";